var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNotGroup)?_c('span',[_c('icon-status',{attrs:{"estado":this.params.value}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }